import { PhoneInput } from '@commenda/kakashi';
import { useFormField } from '../../hooks/useFormField';
import { LabelWithGuidanceTooltip } from './LabelWithGuidanceTooltip';

export const PhoneInputComponent = ({
  fieldId,
  label,
  description,
  props = {},
  guidance,
  validation,
}: any) => {
  const { value, error, disabled, isRequired, setValue } = useFormField<string>(
    fieldId,
    {
      rules: validation?.rules,
      disabledFromProps: props.disabled,
    }
  );

  return (
    <div className="mb-4" data-field-id={fieldId}>
      {(label || description) && (
        <LabelWithGuidanceTooltip
          label={label}
          description={description}
          guidance={guidance?.text}
          isRequired={isRequired}
        />
      )}
      <PhoneInput
        value={value || ''}
        onChange={(next) => setValue(next || '')}
        defaultCountry={props.defaultCountry}
        error={error}
        disabled={disabled}
      />
    </div>
  );
};
